/**
 * Custom hook for managing chat history
 */

import { useState, useCallback } from 'react';
import { ChatMessage, ChatMessageRole } from 'types/types';

export function useChatHistory() {
  const [chatHistory, setChatHistory] = useState<ChatMessage[]>([]);

  const addToHistory = useCallback((message: string, role: ChatMessageRole) => {
    setChatHistory(prev => [...prev, { message, role }]);
  }, []);

  const updateLastEntry = useCallback((message: string) => {
    setChatHistory(prev => {
      const newHistory = [...prev];
      if (newHistory.length > 0) {
        newHistory[newHistory.length - 1].message = message;
      }
      return newHistory;
    });
  }, []);

  const clearHistory = useCallback(() => {
    setChatHistory([]);
  }, []);

  return {
    chatHistory,
    addToHistory,
    updateLastEntry,
    clearHistory
  };
}
